import { render, staticRenderFns } from "./BankInfoOnboarding.vue?vue&type=template&id=eb59d854"
import script from "./BankInfoOnboarding.vue?vue&type=script&lang=js"
export * from "./BankInfoOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports